var _rect, _rect2, _path, _path2, _circle, _path3, _circle2, _circle3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEquityIcon = function SvgEquityIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 28,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.951,
    height: 15.594,
    x: 8.643,
    y: 9.295,
    fill: "#E9F4DB",
    rx: 2.877
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28.451,
    height: 14.739,
    x: 7.016,
    y: 7.816,
    stroke: "#000",
    rx: 0.938
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M6.893 24.913h28.695M6.893 27.046h28.695"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M11.089 7.694c.076 1.524-.675 4.572-4.286 4.572M35.963 12.12c-1.524.077-4.572-.674-4.572-4.285M6.662 18.252c1.524-.076 4.572.675 4.572 4.286M31.536 22.538c-.076-1.524.675-4.572 4.286-4.572"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.563,
    cy: 10.184,
    r: 0.163,
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D7C54",
    d: "M23.934 17.017c0 .34-.082.664-.248.974a2.029 2.029 0 0 1-.747.758c-.332.202-.737.314-1.213.336v.866h-.476v-.877c-.643-.058-1.162-.267-1.56-.628a1.935 1.935 0 0 1-.638-1.364h.812c.029.325.159.62.39.888.238.26.57.418.996.476v-2.999a8.46 8.46 0 0 1-1.17-.39 1.884 1.884 0 0 1-.736-.595c-.202-.274-.303-.639-.303-1.094 0-.57.198-1.039.596-1.407.396-.375.934-.577 1.613-.606v-.91h.476v.92c.599.058 1.079.253 1.44.585.36.332.574.747.639 1.245h-.802c-.043-.267-.176-.516-.4-.747-.217-.23-.509-.375-.877-.433v2.89c.47.123.852.253 1.148.39.303.13.555.332.757.607.202.274.303.646.303 1.115Zm-4.124-3.681c0 .404.122.71.368.92.252.202.61.372 1.072.509v-2.782c-.433.021-.784.148-1.05.379-.26.23-.39.555-.39.974Zm1.916 5.132c.462-.03.82-.174 1.072-.433a1.38 1.38 0 0 0 .379-.986c0-.411-.127-.721-.38-.93-.245-.21-.602-.387-1.071-.531v2.88Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.219,
    cy: 15.186,
    r: 0.893,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.266,
    cy: 15.186,
    r: 0.893,
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D7C54",
    strokeLinecap: "round",
    d: "M3.094 1.034v3.892M.973 2.967h4.24"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEquityIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Equity_Icon.9ec7cd852b6e345ff8699f90007fadd7.svg";